import { render, staticRenderFns } from "./BotEdit.vue?vue&type=template&id=3f34fb74&scoped=true&"
import script from "./BotEdit.vue?vue&type=script&lang=js&"
export * from "./BotEdit.vue?vue&type=script&lang=js&"
import style0 from "./BotEdit.vue?vue&type=style&index=0&id=3f34fb74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34fb74",
  null
  
)

export default component.exports